import { render, staticRenderFns } from "./AppointmentHxTable.vue?vue&type=template&id=4d05e1ae"
import script from "./AppointmentHxTable.vue?vue&type=script&lang=js"
export * from "./AppointmentHxTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports